var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container mb-56" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 col-lg-6 pb-40" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _vm.bulletPointsEnabled
            ? _vm._l(_vm.bulletPoints, function(bulletPoint, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "font-weight-light" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(bulletPoint.bullet_point) +
                        "\n                "
                    )
                  ]
                )
              })
            : _vm._e()
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-6" }, [
        _c("div", {
          staticClass: "rich-text",
          domProps: { innerHTML: _vm._s(_vm.firstColText) }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-6" }, [
        _c("div", {
          staticClass: "rich-text",
          domProps: { innerHTML: _vm._s(_vm.secondColText) }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }